// Copyright (c) 2019 Comsearch, Inc., All rights reserved

// so we have a simple, consistent way to get a label for a meters/feet value.

const getUnitLabelForMetersAndFeet = unitType => (
  unitType === 'SI'
    ? 'm'
    : 'ft'
)

export default getUnitLabelForMetersAndFeet
